import { useLayoutEffect, useRef } from 'react'
import { HeaderDesktop } from './HeaderDesktop'
import { HeaderMobile } from './HeaderMobile'
import { useHeader } from './useHeader'

export const HeaderUI = (props: ReturnType<typeof useHeader>) => {
  const headerRef = useRef<HTMLElement>(null)

  /**
   * O header é `fixed`, então o conteúdo da página precisa de um deslocamento igual à sua altura.
   * Antes essa altura era replicada como número fixo em 4 lugares (Layout/styles.ts e TopMarquee),
   * o que quebrava a cada mudança de design. Agora ela é medida no DOM e publicada em `--header-h`,
   * que é a única fonte de verdade — o ResizeObserver cobre troca de breakpoint e reflow de fontes.
   */
  useLayoutEffect(() => {
    const element = headerRef.current
    if (!element) return undefined

    const publishHeight = () => {
      const { height } = element.getBoundingClientRect()
      if (height > 0) document.documentElement.style.setProperty('--header-h', `${Math.round(height)}px`)
    }

    publishHeight()

    if (typeof ResizeObserver === 'undefined') return undefined

    const observer = new ResizeObserver(publishHeight)
    observer.observe(element)
    return () => observer.disconnect()
  }, [])

  return (
    <header
      ref={headerRef}
      id="header-home"
      className="fixed top-0 z-10 flex h-auto w-full flex-col items-center justify-center bg-gray-50 text-neutral-800">
      <div className="hidden w-full lg:block">
        <HeaderDesktop {...props} />
      </div>

      <div className="block w-full lg:hidden">
        <HeaderMobile {...props} />
      </div>
    </header>
  )
}
